import Api from './Api';

export default {
	getSingleWishlist(id) {
		return Api.get('get_single_wishlist?id=' + id);
	},
	removeManyFromWishlist(obj) {
		return Api.post('remove_many_from_wishlist', obj);
	},
	moveItem(obj) {
		return Api.post('move_item', obj);
	},
	editTitle(obj) {
		return Api.post('edit_title', obj);
	},
	removeWishlistAndList(obj) {
		return Api.post('remove_wishlist_and_list', obj);
	},
};
